import React from "react";
import { useProductSingleContext } from "../../lib/context/ProductSingleContext/ProductSingleContext";
import { useProductSingleHelpers } from "../lib/useProductSingleHelpers";
import { ConditionalProductPrice } from "../shared/ConditionalProductPrice/ConditionalProductPrice";

import "../SingleProductDetails/SingleProductDetails.scss";
import "./ProductSingleContent.scss";

export const SingleProductContent = () => {
  const { product } = useProductSingleContext();
  const { renderProductFieldsByLanguage } = useProductSingleHelpers();

  return (
    <>
      <div className="SingleProductContent__header">
        {/* <div className="top-content">
          <WishListButton id={product.databaseId} />
        </div> */}
        <h1 className="SingleProduct__content__title">
          {renderProductFieldsByLanguage(product, "titleEn", "name")}
        </h1>
        <ConditionalProductPrice
          productCategories={product?.productCategories}
          regular={product?.regularPrice}
          sale={product?.salePrice}
          onSale={product?.onSale}
        />
      </div>
    </>
  );
};
